<span class="time-field">
        <span class="day-factor" *ngIf="d">{{d}}d </span>
        <span class="hour-factor" [ngClass]="{'grey' : h === '00'}">{{h}}</span>
        <span class="minute-factor">:{{m}}</span>
</span>